"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSet = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importDefault(require("react"));
const Text_1 = __importDefault(require("../Text"));
const makeMyClasses = (hasLabel) => ({
    root: {
        marginTop: 4,
        position: 'relative',
        overflow: 'visible',
        border: `1px solid ${lib_palette_1.default.BorderGrey.main}`,
        borderRadius: 8,
        width: '100%',
        padding: hasLabel ? '12px 16px 8px 16px' : 8,
    },
    label: {
        position: 'absolute',
        top: -8,
        left: 8,
        background: lib_palette_1.default.White.main,
        color: lib_palette_1.default.GreyBlue.main,
        padding: '0 4px',
    },
});
function FieldSet(props) {
    const { children, label } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [!!label]);
    return (react_1.default.createElement(Pane_1.default, { classes: { root: myCss.root } },
        !!label && (react_1.default.createElement(Text_1.default, { variant: "small", className: myCss.label }, label)),
        children));
}
exports.FieldSet = FieldSet;
exports.default = FieldSet;
